import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  GetProviderGQL,
  GetProviderBySlugGQL,
  ListFleetsGQL,
  GetFleetGQL,
  CustomerAssetsGQL,
  OperatorMeGQL,
  CreateFleetGQL,
  UpdateFleetGQL,
} from './good-vibes/good-vibes.graphql-gen';
import { CreateFleetInput, UpdateFleetInput, CustomerAssetType } from './generated/graphql-schema';

@Injectable({ providedIn: 'root' })
export class GoodVibesService {
  private getProviderGQL = inject(GetProviderGQL);
  private getProviderBySlugGQL = inject(GetProviderBySlugGQL);
  private listFleetsGQL = inject(ListFleetsGQL);
  private getFleetGQL = inject(GetFleetGQL);
  private customerAssetsGQL = inject(CustomerAssetsGQL);
  private operatorMeGQL = inject(OperatorMeGQL);
  private createFleetGQL = inject(CreateFleetGQL);
  private updateFleetGQL = inject(UpdateFleetGQL);

  getMe() {
    return this.operatorMeGQL.fetch().pipe(map((r) => r.data?.me));
  }

  getProviders(): Observable<any[]> {
    return this.operatorMeGQL.fetch().pipe(map((r) => r.data?.me?.providers ?? []));
  }

  getProvider(id: string) {
    return this.getProviderGQL.fetch({ variables: { id } }).pipe(map((r) => r.data?.provider));
  }

  getProviderBySlug(slug: string) {
    return this.getProviderBySlugGQL.fetch({ variables: { slug } }).pipe(map((r) => r.data?.providerBySlug));
  }

  listFleets() {
    return this.listFleetsGQL.fetch().pipe(map((r) => r.data?.fleets ?? []));
  }

  getFleet(id: string) {
    return this.getFleetGQL.fetch({ variables: { id } }).pipe(map((r) => r.data?.fleet));
  }

  createFleet(data: { name: string; owner_uid: string }): Observable<any> {
    return this.createFleetGQL.mutate({ variables: { data: data as CreateFleetInput } });
  }

  updateFleet(data: { id: string; discount_id?: string }): Observable<any> {
    return this.updateFleetGQL.mutate({ variables: { data: data as UpdateFleetInput } });
  }

  getCustomerAssets(customerId: string, type?: string) {
    return this.customerAssetsGQL
      .fetch({ variables: { customerId, type: type as CustomerAssetType | undefined } })
      .pipe(map((r) => r.data?.customerAssets ?? []));
  }
}
